import ReactGA from "react-ga4";

const TRACKING_ID = "G-BDPDRNET70"; // 自分のGA4トラッキングID
ReactGA.initialize(TRACKING_ID);

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};